import { render, staticRenderFns } from "./element-input-payment-amount.vue?vue&type=template&id=e5620cda&scoped=true"
import script from "./element-input-payment-amount.vue?vue&type=script&lang=js"
export * from "./element-input-payment-amount.vue?vue&type=script&lang=js"
import style0 from "./element-input-payment-amount.vue?vue&type=style&index=0&id=e5620cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5620cda",
  null
  
)

export default component.exports